/**
 * @generated SignedSource<<97bb83f83bf4bfdeb7219307e34654e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WeeklyPaceSkillSource = "DEMONSTRATED" | "DIRECTLY_PASSED" | "%future added value";
export type StudentSkillGoalsReportByWeekFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dateRanges: ReadonlyArray<DateRangeInput>;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  passedSkillGoal: number;
  siteIds?: ReadonlyArray<string> | null | undefined;
};
export type DateRangeInput = {
  fromDate: any;
  toDate: any;
};
export type DashboardGoalMetByWeekQuery$variables = {
  filter: StudentSkillGoalsReportByWeekFilterInput;
  source: WeeklyPaceSkillSource;
};
export type DashboardGoalMetByWeekQuery$data = {
  readonly studentSkillGoalsReportByWeek: ReadonlyArray<{
    readonly dateRange: {
      readonly fromDate: any;
      readonly toDate: any;
    };
    readonly percentageStudentsPassedGoal: number;
  }>;
};
export type DashboardGoalMetByWeekQuery = {
  response: DashboardGoalMetByWeekQuery$data;
  variables: DashboardGoalMetByWeekQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "source"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "source",
        "variableName": "source"
      }
    ],
    "concreteType": "GoalByWeeks",
    "kind": "LinkedField",
    "name": "studentSkillGoalsReportByWeek",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentageStudentsPassedGoal",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGoalMetByWeekQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGoalMetByWeekQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "09b05609e234b6303558b3b5c5d378a2",
    "id": null,
    "metadata": {},
    "name": "DashboardGoalMetByWeekQuery",
    "operationKind": "query",
    "text": "query DashboardGoalMetByWeekQuery(\n  $filter: StudentSkillGoalsReportByWeekFilterInput!\n  $source: WeeklyPaceSkillSource!\n) {\n  studentSkillGoalsReportByWeek(filter: $filter, source: $source) {\n    dateRange {\n      fromDate\n      toDate\n    }\n    percentageStudentsPassedGoal\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6f81a6f2bec24d9dfdff7d9d8d1c638";

export default node;
